<template>
  <section class="report overview">
    <header v-if="this.$route.path !== '/app/overview'">
      <h4 v-t>Overview</h4>
    </header>
    <div class="card min">
      <dl class="card-content">
        <dt><strong v-t>Total Assets</strong></dt>
        <dd v-if="isLoadingBilling">
          <div class="spinner-container">
            <loading-spinner :size="'20px'" class="spinner" />
          </div>
        </dd>
        <dd v-else class="tab-numbers">{{ getTotalAssets| formatCurrency }}</dd>
      </dl>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from '@/lib/vue';
import filters from '@/lib/utils/filters';
import { loadingSpinner } from '@/components/layout';
import errorStore from '@/store/error';

const _ = {
  errorStore,
};

export default {
  _,
  name: 'Overview',
  filters,
  components: { loadingSpinner },

  computed: {
    ...mapGetters(['isLoadingBilling', 'account', 'getTotalAssets']),
  },

  async created() {
    try {
      await this.fetchAccount();
    } catch (exception) {
      _.errorStore.addError();
    }
  },

  methods: {
    ...mapActions(['fetchAccount']),
  },
};

</script>
